import { render, staticRenderFns } from "./CcNode.vue?vue&type=template&id=21ad4b98&scoped=true"
import script from "./CcNode.vue?vue&type=script&lang=js"
export * from "./CcNode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ad4b98",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-OA/jh-oa-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21ad4b98')) {
      api.createRecord('21ad4b98', component.options)
    } else {
      api.reload('21ad4b98', component.options)
    }
    module.hot.accept("./CcNode.vue?vue&type=template&id=21ad4b98&scoped=true", function () {
      api.rerender('21ad4b98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/officeApproval/common/process/nodes/CcNode.vue"
export default component.exports